<template>
  <div class="dashboard_info">
    <div class="contentTitle">{{ dashboardCommonTitleLabel }}</div>
    <contentSection
      :titleLabel="importantMsgInfoLabel"
      :contentLabel="importantMsgInfoContentLabel"
      :finishButtonLabel="changeButtonLabel"
      @ok="showImportantMsgUpdateModal = true"
    ></contentSection>
    <contentSection
      :titleLabel="mailLabel"
      :contentLabel="mailContentLabel"
      @ok="showMailSendModal = true"
      :finishButtonLabel="createButtonLabel"
    ></contentSection>
    <div class="modal_window" v-if="showImportantMsgUpdateModal">
      <importantMsgModalWindow @close="showImportantMsgUpdateModal = false">
      </importantMsgModalWindow>
    </div>
    <div class="modal_window" v-if="showMailSendModal">
      <mailSendModalWindow
        :type="0"
        :tenantKey="null"
        @close="showMailSendModal = false"
      >
      </mailSendModalWindow>
    </div>
  </div>
</template>

<script>
import contentSection from './contentSection.vue'
import importantMsgModalWindow from '../../modalWindow/importantMsgModalWindow.vue'
import mailSendModalWindow from '../../modalWindow/mailSendModalWindow.vue'

export default {
  data() {
    return {
      dashboardCommonTitleLabel: 'ダッシュボード共通設定',
      importantMsgInfoLabel: '重要なお知らせ',
      mailLabel: 'メール',
      importantMsgInfoContentLabel: '重要なお知らせに表示する内容を変更する',
      mailContentLabel: '登録されているテナントの管理者にメールで通知する',
      changeButtonLabel: '変更',
      addButtonLabel: '追加',
      createButtonLabel: '作成',
      showImportantMsgUpdateModal: false,
      showMailSendModal: false
    }
  },
  computed: {},
  components: {
    contentSection,
    importantMsgModalWindow,
    mailSendModalWindow
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/corporationCommonView/corporationCommonComponents/tenantDashboardInfo.vue